import { QueryKey } from "@tanstack/react-query";
import { IconType } from "../../../icons/Icon";
import { useApiQuery } from "../../../infrastructure/hooks/useApiQuery";
import { AppDialog } from "../../AppDialog/AppDialog";
import { NotesBlock } from "./components/NotesBlock";
import { INoteViewModel } from "./models/noteModel";

interface INotesDialogProps {
  entityId?: number;
  showDialog: boolean;
  onHide: () => void;
  label: string;
  getEndpoint: string;
  createEndpoint: string;
  updateEndpoint: string;
  deleteEndpoint: string;
  noResultsLabel: string;
  /** Extra query keys to invalidate when notes change (e.g. parent list keys). */
  additionalInvalidateKeys?: QueryKey[];
}

export const NotesDialog = ({
  entityId,
  showDialog,
  onHide,
  label,
  getEndpoint,
  createEndpoint,
  updateEndpoint,
  deleteEndpoint,
  noResultsLabel,
  additionalInvalidateKeys,
}: INotesDialogProps) => {
  const { data: notes } = useApiQuery<INoteViewModel[]>({
    queryKey: [getEndpoint, entityId],
    endpoint: `${getEndpoint}?entityId=${entityId}`,
    enabled: entityId !== undefined,
    disableErrorToast: true,
    retry: false,
    globalIsLoading: false,
  });

  const invalidateKeys = [
    [getEndpoint],
    ...(additionalInvalidateKeys ?? []),
  ];

  return (
    <AppDialog
      header={label}
      visible={showDialog}
      headerIconColor="#6366f1"
      headerIconType={IconType.Notes}
      style={{ maxWidth: "400px", width: "100%" }}
      onHide={onHide}
    >
      <NotesBlock
        entityId={entityId ?? 0}
        notes={notes}
        createEndpoint={createEndpoint}
        updateEndpoint={updateEndpoint}
        deleteEndpoint={deleteEndpoint}
        invalidateKeys={invalidateKeys}
        noResultsLabel={noResultsLabel}
      />
    </AppDialog>
  );
};
